import { render, staticRenderFns } from "./DashboardKpis.vue?vue&type=template&id=821f293e&"
import script from "./DashboardKpis.vue?vue&type=script&lang=js&"
export * from "./DashboardKpis.vue?vue&type=script&lang=js&"
import style0 from "./DashboardKpis.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports